// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4acfb175","453":"abed8e94","455":"396cfde1"}[chunkId] + ".chunk.js";
};